import React from "react";
import PropTypes from "prop-types";

/** Components */
import Buttons from "../button/Buttons";
import SearchBar from "../../../components/ui/searchBar/SearchBar";

function CardSection({
  children,
  cardTitle,
  rightButton,
  customHeader,
  headerContent,
  buttonClassName,
  titleButtonClick,
  buttonText,
  searchInput,
  searchText,
  textWithIcon,
  iconImg,
  isIcon,
  iconClass,
  handleChange,
  isButtonVisible,
  titleText,
  isButtonLoading,
  isButtonDisable,
}) {
  return (
    <div
      className={`card-section 
        ${cardTitle ? "card-section-left" : ""}
        ${searchInput && rightButton ? "card-section-between" : ""}
        ${rightButton ? "card-button-only" : ""}
        `}
    >
      {customHeader ? (
        <div className="card-top-title-btn">
          <div className="section-title">{cardTitle}</div>
          <div className="right-action">{headerContent}</div>
        </div>
      ) : (
        <>
          {(cardTitle || rightButton) && (
            <div className="card-top-title-btn">
              {cardTitle && <div className="section-title">{cardTitle}</div>}

              {searchInput && (
                <div className="search-input">
                  <SearchBar searchText={searchText} onChange={handleChange} />
                </div>
              )}

              {isButtonVisible && rightButton && (
                <div className="btn-right-sec">
                  {/* Button to open the Add Craft modal */}
                  <Buttons
                    buttonTypeClassName={buttonClassName}
                    onClick={titleButtonClick}
                    buttonText={buttonText}
                    textWithIcon={textWithIcon}
                    imagePath={iconImg}
                    isIcon={isIcon}
                    titleText={titleText}
                    iconClass={iconClass}
                    isLoading={isButtonLoading}
                    isDisable={isButtonDisable}
                  />
                </div>
              )}
            </div>
          )}
        </>
      )}
      <div className="card-body-sec">{children}</div>
    </div>
  );
}

CardSection.propTypes = {
  children: PropTypes.node,
  cardTitle: PropTypes.string,
  rightButton: PropTypes.bool,
  buttonClassName: PropTypes.string,
  titleButtonClick: PropTypes.func,
  buttonText: PropTypes.string,
  searchInput: PropTypes.bool,
  searchText: PropTypes.string,
  textWithIcon: PropTypes.string,
  titleText:PropTypes.string,
  isIcon:PropTypes.string,
  iconClass:PropTypes.string,
  iconImg: PropTypes.string,
  handleChange: PropTypes.func,
  isButtonVisible: PropTypes.bool,
  isButtonLoading: PropTypes.bool,
  customHeader: PropTypes.bool,
  headerContent: PropTypes.node,
  isButtonDisable: PropTypes.bool,
};

export default CardSection;
